import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 18 18" width={18} height={18}>
    <g id="组_512" data-name="组 512" transform="translate(-9.9 -396.9)" opacity="0.65">
      <g id="充值" transform="translate(9.9 396.9)" fill="currentColor">
        <path
          id="路径_6282"
          data-name="路径 6282"
          d="M99.31,94.244h-6.8a8.893,8.893,0,1,1,8.63-6.712.634.634,0,1,1-1.229-.312,7.635,7.635,0,1,0-7.4,5.755h5.572l-.771-1.088a.634.634,0,0,1,1.035-.733l1.48,2.089a.636.636,0,0,1-.518,1Z"
          transform="translate(-83.511 -76.343)"
        />
        <path
          id="路径_6282_-_轮廓"
          data-name="路径 6282 - 轮廓"
          d="M99.309,94.342h-6.8a8.992,8.992,0,1,1,8.725-6.787.732.732,0,0,1-.891.53.732.732,0,0,1-.53-.89,7.536,7.536,0,1,0-7.305,5.68h5.381l-.661-.932a.734.734,0,0,1,.6-1.157.735.735,0,0,1,.6.31l1.48,2.089a.734.734,0,0,1-.6,1.158Zm-6.8-17.8a8.8,8.8,0,0,0,0,17.6h6.8a.537.537,0,0,0,.437-.845l-1.48-2.089a.537.537,0,0,0-.438-.226.536.536,0,0,0-.436.845l.882,1.244H92.51a7.722,7.722,0,1,1,7.5-5.829.534.534,0,0,0,.387.65.534.534,0,0,0,.65-.387A8.809,8.809,0,0,0,92.51,76.54Z"
          transform="translate(-83.51 -76.342)"
        />
        <path
          id="路径_6283"
          data-name="路径 6283"
          d="M337.484,310.144h-2.645v-1.532h2.645a.634.634,0,1,0,0-1.268h-1.866l1.2-1.81a.634.634,0,1,0-1.058-.7l-1.556,2.355-2.039-2.414a.634.634,0,0,0-.969.819l1.479,1.751h-1.747a.634.634,0,1,0,0,1.268h2.646v1.532h-2.646a.634.634,0,0,0,0,1.268h2.646v1.432a.634.634,0,0,0,1.268,0v-1.432h2.645a.635.635,0,0,0,0-1.27Z"
          transform="translate(-325.102 -299.745)"
        />
        <path
          id="路径_6283_-_轮廓"
          data-name="路径 6283 - 轮廓"
          d="M334.2,313.577a.734.734,0,0,1-.733-.733v-1.333h-2.547a.733.733,0,1,1,0-1.466h2.547v-1.334h-2.547a.733.733,0,1,1,0-1.466h1.534l-1.342-1.588a.733.733,0,0,1,1.12-.946l1.954,2.313,1.483-2.245a.731.731,0,0,1,1.015-.208.726.726,0,0,1,.314.464.737.737,0,0,1-.107.551l-1.1,1.656h1.682a.733.733,0,1,1,0,1.466h-2.547v1.334h2.547a.734.734,0,0,1,0,1.468h-2.547v1.333A.734.734,0,0,1,334.2,313.577Zm-3.279-3.333a.535.535,0,0,0,0,1.07h2.744v1.53a.535.535,0,1,0,1.07,0v-1.53h2.744a.536.536,0,0,0,0-1.072h-2.744v-1.73h2.744a.535.535,0,1,0,0-1.07h-2.05l1.3-1.963a.538.538,0,0,0,.078-.4.53.53,0,0,0-.23-.339.534.534,0,0,0-.741.151l-1.629,2.465-2.124-2.515a.535.535,0,1,0-.818.691l1.617,1.913h-1.961a.535.535,0,1,0,0,1.07h2.744v1.73Z"
          transform="translate(-325.101 -299.744)"
        />
      </g>
    </g>
  </svg>
);

export default CMP;
